import http from '@/utils/http' //引入axios
export const getRepairreCord = data => http.get('/maintenance-center/api/repairrecord', {
    params: data
}) //查找故障類型
export const updataRepairreCord = data => http.put('/maintenance-center/api/repairrecord', data) //編輯故障類型
export const addRepairreCord = data => http.post('/maintenance-center/api/repairrecord', data) //添加故障類型
export const deleteRepairreCord = data => http.delete('/maintenance-center/api/repairrecord', {
    params: data
}) //刪除故障類型
export const getUser = () => http.get('/user-center/api/user/dept/finduser') //刪除故障類型
export const exportCord = data => http.get('/maintenance-center/api/repairrecord/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getRepairreCord,
    updataRepairreCord,
    addRepairreCord,
    deleteRepairreCord,
    getUser,
    exportCord
    // findBarcode
}